<script>
    import {
        Alert,
    } from 'sveltestrap';

    export let errors;

    let errorsArray = [];
    for (let fieldName in errors) {
        errorsArray.push({
            field: fieldName,
            error: errors[fieldName],
        });
    }

    console.log(errorsArray);
</script>

{#if errorsArray.length}
    <Alert color="danger">
        {#each errorsArray as {field, error}}
            <p>
                <strong>{field}</strong>
                <span>{error}</span>
            </p>
        {/each}
    </Alert>
{/if}